import React  from "react";
import {Button, Popover, MenuItem, Menu, Position} from "@blueprintjs/core";
import { I18n, Translate } from "react-redux-i18n";

const circleStatus=[
    "member_gathering",
    "awaiting_commitment",
    "awaiting_purchase",
    "pending",
    "completed"
]

const CircleStatusSelector=({status, statusChanged})=>{ 
    return(
        <Popover
            content={
                <Menu>
                    {circleStatus.map(status=>
                        <MenuItem key={status} text={I18n.t(`circle_status.${status}`)} onClick={()=>{statusChanged(status)}} />
                    )}
                </Menu>
            }
            position={Position.BOTTOM_LEFT}
        >
            <Button rightIcon="caret-down" className="input-button right">
                <Translate value={`circle_status.${status}`} />
            </Button>
        </Popover>
    );
}

export default CircleStatusSelector;